import { Moment } from "moment";
import { SituacaoSincronizacao } from "./enum";

export default class Conexao implements IConexao {
  public id!: string;
  public itemId?: string;
  public corretora!: string;
  public dataConexao!: Moment;
  public dataAtualizacao!: Moment;
  public situacao!: SituacaoSincronizacao;
  public conta!: string;
  public erro?: any;
  public conexaoAntiga!: boolean;

  // public pdfs!: number;
  // Klavi
  // public idKlavi?: string;
  // public connectionKey!: string;

  constructor(param: IConexao) {
    Object.assign(this, param);
  }
}

interface IConexao {
  id: string;
  itemId?: string;
  corretora: string;
  dataConexao: Moment;
  dataAtualizacao: Moment;
  situacao: SituacaoSincronizacao;
  conta: string;
  erro?: any;

  conexaoAntiga: boolean;
  // pdfs: number;
  // idKlavi?: string;
  // connectionKey: string;
}
